module.exports = __webpack_public_path__ + "media/images/help/about/icon-reason-3-bf3610c4fafdb7f217d84294d3cb0ee1.svg";